module.exports = __webpack_public_path__ + "img/perdimos.9b32b897.png";